import {
	FontIconCompat as FontIcon,
	HoverCardCompat as HoverCard,
	HoverCardType,
	LabelCompat as Label,
	LinkCompat as Link,
	mergeStyleSets,
	SearchBoxCompat as SearchBox,
	SeparatorCompat as Separator,
	ShimmerCompat as Shimmer,
	SpinnerCompat as Spinner,
	StackCompat as Stack,
	Theme,
	useTheme,
} from 'components/FluentUICompat';
import {useOutsideClick} from 'hooks';
import React, {
	Ref,
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from 'react';
import {
	PogisDocument,
	Regulation,
	RegulatoryDocument,
	Requirement,
} from 'types';
import {v4 as uuidv4} from 'uuid';
import {
	useGetPogisHoverContentQuery,
	useGetRegulationHoverContentQuery,
	useGetRegulatoryDocumentHoverContentQuery,
	useGetRequirementHoverContentQuery,
} from './hooks/useHoverContent.generated';
import {
	InfoSectionPOGIS,
	InfoSectionRegulation,
	InfoSectionRegulatoryDocument,
	InfoSectionRequirement,
} from 'features/Search/components/SearchCards/SearchResultCards';

type EntityHoverContentProps = {
	id: string;
};

export const RegulationHoverContent: React.FC<EntityHoverContentProps> = ({
	id,
}) => {
	const {data, loading} = useGetRegulationHoverContentQuery({
		variables: {regulationId: id},
	});

	return (
		<div style={{padding: 10, width: '45vw'}}>
			{loading ? (
				<Spinner />
			) : (
				<InfoSectionRegulation
					item={data?.regulation as Regulation}
					infoSectionExpanded={true}
				/>
			)}
		</div>
	);
};

export const RegulatoryDocumentHoverContent: React.FC<
	EntityHoverContentProps
> = ({id}) => {
	const {data, loading} = useGetRegulatoryDocumentHoverContentQuery({
		variables: {regDocId: id},
	});

	return (
		<div style={{padding: 10}}>
			{loading ? (
				<Spinner />
			) : (
				<InfoSectionRegulatoryDocument
					item={data?.regulatoryDocument as RegulatoryDocument}
					infoSectionExpanded={true}
				/>
			)}
		</div>
	);
};

export const RequirementHoverContent: React.FC<EntityHoverContentProps> = ({
	id,
}) => {
	const {data, loading} = useGetRequirementHoverContentQuery({
		variables: {requirementId: id},
	});

	return (
		<div style={{padding: 10}}>
			{loading ? (
				<Spinner />
			) : (
				<InfoSectionRequirement
					item={data?.requirement as Requirement}
					infoSectionExpanded={true}
				/>
			)}
		</div>
	);
};

export const PogisHoverContent: React.FC<EntityHoverContentProps> = ({id}) => {
	const {data, loading} = useGetPogisHoverContentQuery({
		variables: {pogisId: id},
	});

	return (
		<div style={{padding: 10}}>
			{loading ? (
				<Spinner />
			) : (
				<InfoSectionPOGIS
					item={data?.pogisDocument as PogisDocument}
					infoSectionExpanded={true}
				/>
			)}
		</div>
	);
};
